/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Marketing20Inputs */

const en__field_enum_csjensblank_marketing20 = /** @type {(inputs: _Field_Enum_Csjensblank_Marketing20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media, Communication & Marketing`)
};

const de__field_enum_csjensblank_marketing20 = /** @type {(inputs: _Field_Enum_Csjensblank_Marketing20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien, Kommunikation & Marketing`)
};

/**
* | output |
* | --- |
* | "Media, Communication & Marketing" |
*
* @param {_Field_Enum_Csjensblank_Marketing20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_marketing20 = /** @type {((inputs?: _Field_Enum_Csjensblank_Marketing20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Marketing20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_marketing20(inputs)
	return de__field_enum_csjensblank_marketing20(inputs)
});
export { _field_enum_csjensblank_marketing20 as "_field_enum_CSJENSBLANK_MARKETING" }